// @flow
import api from 'tim-api';
import { goalTransferApproval } from 'endPoints';

export const state = {
  list: []
};

export const getters = {
  list: (state: Object) => state.list
};

export const mutations = {
  SET_LIST(state: Object, list: Array<Object>) {
    state.list = list;
  }
};

export const actions = {
  // eslint-disable-next-line
  fetchList({ commit }: Action, search: string = '') {
    return api.get(`${goalTransferApproval}?search=${search}`).then(({ data }) => {
      commit('SET_LIST', data);
    });
  },
  // eslint-disable-next-line
  fetchFile({ commit }, Action) {
    return api.get(`${goalTransferApproval}/download`, {
      responseType: 'blob'
    });
  },
  // eslint-disable-next-line
  uploadFile({ commit }: Action, filecsv: Object) {
    return api.post(`${goalTransferApproval}/upload`, filecsv);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
